module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/spacing-horizontal-sm-5fe0afaa867183c22a0709980f513c9c.svg";